import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="min-h-screen bg-background p-4 sm:p-8">
            <div className="max-w-3xl mx-auto">
                <a href="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6">
                    <ArrowLeft className="w-4 h-4" /> 返回登录
                </a>

                <h1 className="text-3xl font-bold text-foreground mb-6">隐私政策</h1>
                <p className="text-muted-foreground mb-4">最后更新：2024年12月</p>

                <div className="prose prose-invert max-w-none space-y-6 text-foreground/90">
                    <section>
                        <h2 className="text-xl font-semibold mb-3">1. 信息收集</h2>
                        <p>我们收集以下类型的信息：</p>
                        <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                            <li>WhatsApp 用户的电话号码和用户名</li>
                            <li>聊天消息内容（用于客服功能）</li>
                            <li>登录账户信息</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">2. 信息使用</h2>
                        <p className="text-muted-foreground">我们使用收集的信息来：</p>
                        <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                            <li>提供客户服务功能</li>
                            <li>处理和回复 WhatsApp 消息</li>
                            <li>改进我们的服务</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">3. 信息保护</h2>
                        <p className="text-muted-foreground">
                            我们采取适当的安全措施保护您的个人信息，包括 HTTPS 加密传输和安全的数据存储。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">4. 数据保留</h2>
                        <p className="text-muted-foreground">
                            聊天记录将根据您选择的保留期限（7天、30天、60天、90天或永久）进行保存。
                            您可以随时清除聊天记录。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">5. 第三方服务</h2>
                        <p className="text-muted-foreground">
                            本应用使用 Meta WhatsApp Business API 进行消息收发。
                            请参阅 Meta 的隐私政策了解更多信息。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">6. 联系我们</h2>
                        <p className="text-muted-foreground">
                            如有任何隐私相关问题，请联系系统管理员。
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
